import { config } from '../../core/'

export default class ScrollAnimation {
  constructor() {
    this.elements = [...document.querySelectorAll('[data-animate]')]
    if(!this.elements.length) return;
    this.mobile = window.innerWidth < config.viewport.sm

    window.addEventListener('load', () => this.init());
  }

  init() {
    this.elements.forEach(element => {
      if (element.dataset.onlyMd === "true" && !this.mobile) return;
      
      switch (element.dataset.animate) {
        case 'fade-in':
          this.fadeIn(element);
          break;
        case 'fade-in-up':
          this.fadeInUp(element);
          break;
        case 'zoom-in':
          this.zoomIn(element);
          break;
        case 'slide-in-left':
          this.slideInLeft(element);
          break;
        case 'fill':
          this.animateFill(element);
          break;
        case 'mogoo':
          this.animateMogoo(element);
          break;
        case 'lucy':
          this.animateLucy(element);
          break;
        case 'slider':
          this.animateSlider(element);
          break;
      }
    });
  }

  fadeIn(element) {
    gsap.set(element, { autoAlpha: 0 })

    gsap.to(element, {
      autoAlpha: 1,
      duration: 0.5,
      ease: "power3.out",
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
    });
  }

  fadeInUp(element) {
    gsap.set(element, { autoAlpha: 0, y: element.dataset.y ?? 30 })

    gsap.to(element, {
      autoAlpha: 1,
      y: 0,
      duration: 0.5,
      ease: "power3.out",
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
    });
  }

  zoomIn(element) {
    gsap.set(element, { autoAlpha: 0, scale: element.dataset.scale ?? 0.7 })

    gsap.to(element, {
      autoAlpha: 1,
      scale: 1,
      duration: 0.4,
      ease: "back.out(1.5)",
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
    });
  }

  slideInLeft(element) {
    const items = [...element.querySelectorAll('[data-slide-in-left-item]')]

    gsap.set(items, { autoAlpha: 0, xPercent: -50 })

    gsap.to(items, {
      autoAlpha: 1,
      xPercent: 0,
      duration: 0.55,
      ease: "back.out(1.5)",
      stagger: 0.15,
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
    });
  }

  animateFill(element) {
    gsap.set(element, { autoAlpha: 0, xPercent: 15 })

    gsap.to(element, {
      autoAlpha: 1,
      xPercent: 0,
      duration: 0.6,
      ease: "power3.out",
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
    });
  }

  animateMogoo(element) {
    gsap.set(element, { autoAlpha: 0, yPercent: 100 })

    gsap.to(element, {
      autoAlpha: 1,
      yPercent: 0,
      duration: 0.6,
      ease: "back.out(1.7)",
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
    });
  }

  animateLucy(element) {
    gsap.set(element, { autoAlpha: 0, xPercent: -25, rotate: 5 })

    gsap.to(element, {
      autoAlpha: 1,
      xPercent: 0,
      rotate: 0,
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
      },
      onComplete: () => {
        element.classList.add('is-animated');
      }
    });
  }

  animateSlider(element) {
    gsap.set(element, { xPercent: 300 })

    gsap.to(element, {
      xPercent: 0,
      duration: 1.5,
      ease: 'expo.out',
      stagger: 0.15,
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
      },
    });
  }
}
